// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bbk_CvFnu1YQZKz0MjJ9{align-items:center;margin-bottom:19px;padding-left:7px}.bbk_CvFnu1YQZKz0MjJ9 input{height:20px;font-size:16px}.bbk_CvFnu1YQZKz0MjJ9 input::placeholder{color:var(--content-neutral-primary)}.wbzDN9l78wnrH3WWJcDL{min-height:420px}.oTvd0qLiSXoLUZrilw_l{justify-content:space-between;align-items:center;gap:12px;display:flex}.VBwNzzBWFX05rwOXIpYY{align-items:center;gap:8px;min-width:0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `bbk_CvFnu1YQZKz0MjJ9`,
	"tableWrap": `wbzDN9l78wnrH3WWJcDL`,
	"contactColumn": `oTvd0qLiSXoLUZrilw_l`,
	"contactColumnName": `VBwNzzBWFX05rwOXIpYY`
};
export default ___CSS_LOADER_EXPORT___;
